import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["component"];
import React from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import { flowRight as compose } from 'es-toolkit/compat';
var DragDropWrapperComponent = function DragDropWrapperComponent(_ref) {
  var Component = _ref.component,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Component, props);
};
var dragSource = {
  beginDrag: function beginDrag(props) {
    return {
      id: props.itemId,
      index: props.index,
      originalIndex: props.index,
      label: props.dragLabel
    };
  },
  endDrag: function endDrag(props, monitor) {
    var dragItem = monitor.getItem();
    if (!monitor.didDrop()) {
      props.onMove(dragItem.id, dragItem.originalIndex);
    } else if (props.onDragEnd) {
      props.onDragEnd();
    }
  }
};
var dropTarget = {
  hover: function hover(props, monitor) {
    var dragItem = monitor.getItem();
    var hoverIndex = props.index;
    if (dragItem.id !== props.itemId) {
      props.onMove(dragItem.id, hoverIndex);
      dragItem.index = hoverIndex;
    }
  }
};
export default compose(DropTarget(function (props) {
  return props.type;
}, dropTarget, function (connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
}), DragSource(function (props) {
  return props.type;
}, dragSource, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}))(DragDropWrapperComponent);